/**
 * Resolves the effective model for a user.
 *
 * Rules (applied in order):
 * 1. No preferred model, or preferred model is not in the allowed list → use admin default.
 * 2. Admin set the default *after* the user last chose their preferred model → admin default wins.
 * 3. Otherwise → user's preferred model wins.
 *
 * Launch-safe: if `defaultSetAt` is null/undefined the admin has not yet re-affirmed the
 * default since this feature shipped, so no override is applied and existing user choices
 * are fully preserved.
 */
export function resolveEffectiveModel(
  preferredModel: string | undefined | null,
  preferredModelSetAt: number | undefined | null,
  defaultModelId: string | undefined | null,
  defaultSetAt: number | Date | undefined | null,
  allowedModelIds: Set<string> | string[],
): string | undefined {
  const allowed =
    allowedModelIds instanceof Set ? allowedModelIds : new Set(allowedModelIds);
  const defaultId = defaultModelId ?? undefined;

  if (!preferredModel || !allowed.has(preferredModel)) {
    return defaultId;
  }

  if (defaultSetAt !== null && defaultSetAt !== undefined) {
    const defaultTs =
      defaultSetAt instanceof Date ? defaultSetAt.getTime() : Number(defaultSetAt);
    const userTs = preferredModelSetAt ?? null;
    if (userTs === null || userTs < defaultTs) {
      return defaultId;
    }
  }

  return preferredModel;
}
